import request from '@/utils/request'

export function listOnRoad(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/cert/listOnRoad',
    method: 'get',
    params
  })
}

// 详情
export function detailOnRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/cert/detailOnRoad/${id}`,
    method: 'get'
  })
}

// 非道路列表
export function listOffRoad(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/cert/listOffRoad',
    method: 'get',
    params
  })
}

// 非道路详情
export function detailOffRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/cert/detailOffRoad/${id}`,
    method: 'get'
  })
}

// 安全检验报告列表
export function listSecurity(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/cert/listSecurity',
    method: 'get',
    params
  })
}

// 安全检验报告详情
export function detailSecurity(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/cert/detailSecurity/${id}`,
    method: 'get'
  })
}
